export default __webpack_public_path__ + "static/media/pho3_meyoko.06188add.jpg";